import IntegrationDiagram from "../IntegrationDiagram";

interface SyncingPanelProps {
  className: string;
}

const SyncingPanel = ({ className }: SyncingPanelProps) => (
  <div data-cy="connect-services-step-3" className={className}>
    <h1 className="tw-m-0 tw-text-center tw-text-28d tw-font-normal tw-text-gray-75">
      Setting Up the Integration
    </h1>

    {/* Figma: 96px heading→body, 40px body→diagram. PANEL_BASE contributes 16px
        of flex gap, so the explicit margins are the remainder. */}
    <p className="tw-m-0 tw-mt-[80px] tw-text-center tw-text-14d tw-font-normal tw-text-gray-75">
      Just a moment...
    </p>

    <div className="tw-mt-[24px]">
      <IntegrationDiagram status="syncing" />
    </div>
  </div>
);

export default SyncingPanel;
